var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 5.83366C24.5 5.18933 23.9777 4.66699 23.3333 4.66699H4.66667C4.02234 4.66699 3.5 5.18933 3.5 5.83366C3.5 6.47799 4.02234 7.00033 4.66667 7.00033H23.3333C23.9777 7.00033 24.5 6.47799 24.5 5.83366Z",
    fill: "#18191A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 14.0003C24.5 13.356 23.9777 12.8337 23.3333 12.8337H4.66667C4.02234 12.8337 3.5 13.356 3.5 14.0003C3.5 14.6447 4.02234 15.167 4.66667 15.167H23.3333C23.9777 15.167 24.5 14.6447 24.5 14.0003Z",
    fill: "#18191A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 21.0003C23.9777 21.0003 24.5 21.5227 24.5 22.167C24.5 22.8113 23.9777 23.3337 23.3333 23.3337H4.66667C4.02234 23.3337 3.5 22.8113 3.5 22.167C3.5 21.5227 4.02234 21.0003 4.66667 21.0003H23.3333Z",
    fill: "#18191A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIcon);
export default __webpack_public_path__ + "static/media/sidebar_icon.d19e897e423d18101dc7afa3b6431cdc.svg";
export { ForwardRef as ReactComponent };